export type HagerBridgeResponseErrorFormat = { response?: { data?: { errorCode?: string } } }

export enum HagerBridgeErrorResponse {
  INSTALLATION_NOT_FOUND = 'INSTALLATION_NOT_FOUND',
}
